//
// helpers/outer-height.js - get element height incl. margin
//

export default function outer_height(el) {
  const height = el.offsetHeight;
  const style = getComputedStyle(el);

  return height + parseInt(style.marginTop) + parseInt(style.marginBottom);
}
